import { OneCloudRoleOrgDataType } from '../../clients/oneCloud/relationshipMgt/types';
import { TenantNodeType, TenantVisualizationType } from './strategy/types';

export default class TenantUtils {
  public static _convertStratusTenantNodeToTenantVisualizationType(
    tenantNode: TenantNodeType
  ): TenantVisualizationType {
    return {
      id: tenantNode.nodeId,
      name: tenantNode.accountName || tenantNode.description,
      type: tenantNode.type,
      roleCategory: tenantNode.roleCategory,
      roleName: tenantNode.roleCategory, // Stratus's API only exposes role category
      roles: tenantNode.roleCategory
        ? [{ category: tenantNode.roleCategory }]
        : []
    };
  }

  public static _convertOnecloudOrgToTenantVisualizationType({
    org: organization,
    role
  }: OneCloudRoleOrgDataType): TenantVisualizationType {
    const mappedRoles =
      role?.map((r) => ({ category: r.type, name: r.name })) || [];
    return {
      id: organization.id,
      name: organization.name,
      type: organization?.category?.type || organization.type,
      roleCategory: role?.[0]?.type,
      roleName: role?.[0]?.name,
      roles: mappedRoles
    };
  }
}
